import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,Progress
} from "reactstrap";
import { Link,useNavigate  } from "react-router-dom";

import classNames from "classnames";

//import Charts
import StackedColumnChart from "./StackedColumnChart";

//import action
import { getChartsData as onGetChartsData } from "../../store/actions";

import modalimage1 from "../../assets/images/product/img-7.png";
import modalimage2 from "../../assets/images/product/img-4.png";

// Pages Components
import WelcomeComp from "./WelcomeComp";
import MonthlyEarning from "./MonthlyEarning";
import SocialSource from "./SocialSource";
import ActivityComp from "./ActivityComp";
import TopCities from "./TopCities";
import LatestTranaction from "./LatestTranaction";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

//redux
import { useSelector, useDispatch } from "react-redux";

const Dashboard = props => {
  const navigate = useNavigate();
  const [modal, setmodal] = useState(false);
  const [subscribemodal, setSubscribemodal] = useState(false);
  const [dashboardData, setDashboardData] = useState({});
  const [error, setError] = useState(null);
  
  const baseurl = process.env.REACT_APP_BASE_URL;
const user = JSON.parse(localStorage.getItem("authUser"));

 

const fetchdashboardData = async () => {
          try {
            setError(null);
            const response = await fetch(`${baseurl}/admin/dashboard/dashboard?user_id=${user.id}`);
            if (!response.ok) throw new Error("Network response was not ok");
            const data = await response.json();
            setDashboardData(data);
          } catch (error) {
            setError(error.message);
          }
        };
      
        useEffect(() => {
          fetchdashboardData();
        }, []);

  
  const reports = [
  { title: "Carts", iconClass: "bx-cart", description: dashboardData.carts },
  { title: "Open Orders", iconClass: "bx-package", description: dashboardData.openOrders },
  { title: "New Customer", iconClass: "bx-user", description: dashboardData.customers },
  { title: "Ticket", iconClass: "bx-support", description: dashboardData.tickets },
  { title: "BOM Request", iconClass: "bx-layer", description: dashboardData.bomRequest },
  { title: "Product Request", iconClass: "bx-package", description: dashboardData.productRequest },
];

  useEffect(() => {
    setTimeout(() => {
      setSubscribemodal(true);
    }, 2000);
  }, []);

const { chartsData } = useSelector(state => ({
  chartsData: state.Dashboard.chartsData
}));

const [periodData, setPeriodData] = useState({
  categories: [],
  series: []
});


const [periodType, setPeriodType] = useState("weekly");

const userData = dashboardData.userData || {
  fullname: "",
  role_name: "",
  orders: 0,
  revenue: 0
};
const dispatch = useDispatch();

useEffect(() => {
  dispatch(onGetChartsData("weekly"));
}, []);

useEffect(() => {
  if (chartsData && chartsData.series) {
    setPeriodData(chartsData);
  }
}, [chartsData]);

const onChangeChartPeriod = pType => {
 
  setPeriodType(pType);
  dispatch(onGetChartsData(pType));
};
const getLink = (title, type) => {
  switch (title) {
    case "Carts":
      return `/manage-request/cart/${type}-customers`;

    case "Open Orders":
      return `/manage-orders/${type}-customer`;

    case "New Customer":
      return `/manage-customers/${type}`;

    case "Ticket":
      return `/manage-ticket`;

    case "BOM Request":
      return `/manage-request/bom`;

    case "Product Request":
      return `/manage-request/new-product`;


    default:
      return "#";
  }
};
  //meta title
  document.title = "Dashboard | Admin";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Dashboards")}
            breadcrumbItem={props.t("Dashboard")}
          />

          { <Row>
            <Col xl="4">
              <WelcomeComp userData={userData} />
              {/* <MonthlyEarning /> */}
            </Col>
            <Col xl="8">
              <Row>
      {reports.map((report, key) => {
        const isSplitCard =
          report.title === "Carts" ||
          report.title === "Open Orders" ||
          report.title === "New Customer";

        const isSplitCardnon =
          report.title === "Ticket" ||
          report.title === "BOM Request" ||
          report.title === "Product Request";

        return (
          <Col xl="4" key={key}>
            <Card className="overflow-hidden card">
              <CardBody>
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <p className="text-muted mb-1 small">
                      {report.title}
                    </p>

                    <h3 className="fw-bold mb-2">
  <Link
    to={getLink(report.title, "individual")}
    onClick={(e) => e.stopPropagation()}
    className="text-decoration-none text-dark"
  >
    {isSplitCard
      ? (report.description?.individual || 0) +
        (report.description?.corporate || 0)
      : report.description || 0}
  </Link>
</h3>
                  </div>

                  <div className="avatar-sm">
                    <span className="avatar-title rounded-circle bg-primary">
                      <i
                        className={`bx ${report.iconClass} font-size-20`}
                      />
                    </span>
                  </div>
                </div>

                {isSplitCard && (
                  <div className="mt-2">
                    {/* Individual */}
                    <Link
                      to={getLink(report.title, "individual")}
                      onClick={(e) => e.stopPropagation()}
                      className="text-decoration-none"
                    >
                      <div className="d-flex justify-content-between py-1">
                        <small className="text-primary fw-semibold">
                          Individual
                        </small>

                        <small className="fw-bold text-dark">
                          {report.description?.individual || 0}
                        </small>
                      </div>
                    </Link>

                    {/* Corporate */}
                    <Link
                      to={getLink(report.title, "corporate")}
                      onClick={(e) => e.stopPropagation()}
                      className="text-decoration-none"
                    >
                      <div className="d-flex justify-content-between py-1">
                        <small className="text-success fw-semibold">
                          Corporate
                        </small>

                        <small className="fw-bold text-dark">
                          {report.description?.corporate || 0}
                        </small>
                      </div>
                    </Link>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        );
      })}
    </Row>
            </Col>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div className="d-sm-flex flex-wrap">
                    <h4 className="card-title mb-4">Invoice</h4>
                    <div className="ms-auto">
                      <ul className="nav nav-pills">
                        <li className="nav-item">
                          <Link
                            to="#"
                            className={classNames(
                              { active: periodType === "weekly" },
                              "nav-link"
                            )}
                            onClick={() => {
                              onChangeChartPeriod("weekly");
                            }}
                            id="one_week"
                          >
                            Week
                          </Link>{" "}
                        </li>
                        <li className="nav-item">
                          <Link
                            to="#"
                            className={classNames(
                              { active: periodType === "monthly" },
                              "nav-link"
                            )}
                            onClick={() => {
                              onChangeChartPeriod("monthly");
                            }}
                            id="one_month"
                          >
                            Month
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="#"
                            className={classNames(
                              { active: periodType === "yearly" },
                              "nav-link"
                            )}
                            onClick={() => {
                              onChangeChartPeriod("yearly");
                            }}
                            id="one_year"
                          >
                            Year
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <StackedColumnChart periodData={periodData} dataColors='["--bs-primary", "--bs-warning", "--bs-success"]' />
                </CardBody>
              </Card>
            </Col>
          </Row> }

          { <Row>
            <Col xl="6">
            <Card>
                <CardBody>
                  <div class="mb-4 h4 card-title">Material Planning</div>
            <div className="table-responsive mt-4">
            <Table className="table align-middle table-nowrap">
                <thead>
                  <tr>
                    <th scope="col">Product Name</th>
                    <th scope="col">Total Order Qty</th>
                    <th scope="col">Status</th>
                  </tr>
                </thead>
              <tbody>
                {dashboardData.materialPlanning?.map(materialplanning => {

  const status =
    materialplanning.stock_qty >= materialplanning.reserved_quantity
      ? "Available"
      : "Not Available";

  return (
    <tr key={materialplanning.id}>
      
      <td style={{ width: "50%" }}>
        <p className="mb-0">{materialplanning.product_name}</p>
      </td>

      <td style={{ width: "25%" }}>
        <p className="mb-0">{materialplanning.reserved_quantity}</p>
      </td>

      <td>
        <span className={`badge ${status === "Available" ? "bg-success" : "bg-danger"}`}>
          {status}
        </span>
      </td>

    </tr>
  );
})}
                
                
              </tbody>
            </Table>
            
          </div>
          </CardBody>
            </Card>
              
            </Col>
            <Col xl="6">
            <Card>
                <CardBody>
              <div class="mb-4 h4 card-title">Latest Order</div>
            <div className="table-responsive mt-4">
            <Table className="table align-middle table-nowrap">
                <thead>
                  <tr>
                    <th scope="col">Customer</th>
                    <th scope="col">Type</th>
                    <th scope="col">Order Id</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Status</th>
                  </tr>
                </thead>
              <tbody>
                {dashboardData.latestOrders?.map(order => (
                <tr key={order.id}>
                <td  style={{ width: "50%" }} >{order.company_name}</td>
                <td style={{ width: "25%" }}>{order.customer_type}</td>
                <td>{order.order_id}</td>
                <td>{order.total_amount}</td>
                <td>{order.order_status}</td>
                </tr>
                ))}
                
                
              </tbody>
            </Table>
            
          </div>
          </CardBody>
          </Card>
            </Col>

            
          </Row> }

          
        </Container>
      </div>

      {/* subscribe ModalHeader */}
      {/* <Modal
        isOpen={subscribemodal}
        role="dialog"
        autoFocus={true}
        centered
        data-toggle="modal"
        toggle={() => {
          setSubscribemodal(!subscribemodal);
        }}
      >
        <div>
          <ModalHeader
            className="border-bottom-0"
            toggle={() => {
              setSubscribemodal(!subscribemodal);
            }}
          ></ModalHeader>
        </div>
        <div className="modal-body">
          <div className="text-center mb-4">
            <div className="avatar-md mx-auto mb-4">
              <div className="avatar-title bg-light  rounded-circle text-primary h1">
                <i className="mdi mdi-email-open"></i>
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-xl-10">
                <h4 className="text-primary">Subscribe !</h4>
                <p className="text-muted font-size-14 mb-4">
                  Subscribe our newletter and get notification to stay update.
                </p>

                <div
                  className="input-group rounded bg-light"
                >
                  <Input
                    type="email"
                    className="form-control bg-transparent border-0"
                    placeholder="Enter Email address"
                  />
                  <Button color="primary" type="button" id="button-addon2">
                    <i className="bx bxs-paper-plane"></i>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal> */}

      <Modal
        isOpen={modal}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        tabIndex="-1"
        toggle={() => {
          setmodal(!modal);
        }}
      >
        <div>
          <ModalHeader
            toggle={() => {
              setmodal(!modal);
            }}
          >
            Order Details
          </ModalHeader>
          <ModalBody>
            <p className="mb-2">
              Product id: <span className="text-primary">#SK2540</span>
            </p>
            <p className="mb-4">
              Billing Name: <span className="text-primary">Neal Matthews</span>
            </p>

            <div className="table-responsive">
              <Table className="table table-centered table-nowrap">
                <thead>
                  <tr>
                    <th scope="col">Product</th>
                    <th scope="col">Product Name</th>
                    <th scope="col">Price</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">
                      <div>
                        <img src={modalimage1} alt="" className="avatar-sm" />
                      </div>
                    </th>
                    <td>
                      <div>
                        <h5 className="text-truncate font-size-14">
                          Wireless Headphone (Black)
                        </h5>
                        <p className="text-muted mb-0">$ 225 x 1</p>
                      </div>
                    </td>
                    <td>$ 255</td>
                  </tr>
                  <tr>
                    <th scope="row">
                      <div>
                        <img src={modalimage2} alt="" className="avatar-sm" />
                      </div>
                    </th>
                    <td>
                      <div>
                        <h5 className="text-truncate font-size-14">
                          Hoodie (Blue)
                        </h5>
                        <p className="text-muted mb-0">$ 145 x 1</p>
                      </div>
                    </td>
                    <td>$ 145</td>
                  </tr>
                  <tr>
                    <td colSpan="2">
                      <h6 className="m-0 text-end">Sub Total:</h6>
                    </td>
                    <td>$ 400</td>
                  </tr>
                  <tr>
                    <td colSpan="2">
                      <h6 className="m-0 text-end">Shipping:</h6>
                    </td>
                    <td>Free</td>
                  </tr>
                  <tr>
                    <td colSpan="2">
                      <h6 className="m-0 text-end">Total:</h6>
                    </td>
                    <td>$ 400</td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              color="secondary"
              onClick={() => {
                setmodal(!modal);
              }}
            >
              Close
            </Button>
          </ModalFooter>
        </div>
      </Modal>
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(Dashboard);
